const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	model: {
		upsertGranted: false
	},

	methods: {
		sanitizeResourceRegisterContent: function(data, actionSourceName, resourceRegisterContent){
			if(resourceRegisterContent){
				this.model.mailingListID = resourceRegisterContent.mailingListID;
			}
		},

		prepareForSubmit: function(){
			var dirtyAdditionalData = ((((this.model.dirtyFields || {}).data || {}).children || {}).additionalData || {}).data || {};
			if(dirtyAdditionalData.attributes){
				dirtyAdditionalData.attributes = utils.replace((((((this.resourceData || {}).data || {}).children || {}).additionalData || {}).data || {}).attributes || {}, dirtyAdditionalData.attributes);
			}

			return utils.promise.resolve();
		},

		getResourceAdditionalHeaders: function(storage, actionKey, fieldCode){
			if(actionKey === 'submit' && this.model.upsertGranted){
				return { fec_force_upsert: true };
			}
		},

		handleError: function(context){
			var self = this;
			var baseError = utils.extractBaseError(context.error) || {};

			if(baseError.statusCode === 409){
				if(baseError.errorCode === 'UNIQUE_MAILING-LIST-ID_EMAIL-HASH_ANONYMIZED_ERROR'){
					return self.performDecision(
						'confirm',
						{
							component:  self,
							title:      storage.__('hint.newsletter.subscriber.reactivate.title'),
							message:    storage.__('hint.newsletter.subscriber.reactivate.message')
						}
					).then(function(confirmationContext){
						if(confirmationContext.decision.type === 'yes'){
							self.model.upsertGranted = true;
							self.submit().then(function(response){
								self.closest('base_modal_modal', function(modal){
									self.closest('templates_newsletter_subscribers_head', function(head){
										head.refreshList();
									});
									modal.hide();
								});
							});
							self.model.upsertGranted = false;
						}
						return utils.promise.resolve(context);
					});
				}

				if(baseError.errorCode === 'UNIQUE_MAILING-LIST-ID_EMAIL-HASH_ERROR'){
					return self.performAction(
						self.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:newsletter.subscriber.insert.emailExists'
							}
						})
					);
				}
			}

			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		},

		onBeforeRender: function(){
			var subscriberAttributes = (this.resourceData.data || {}).attributes || {};
			if(subscriberAttributes.email && subscriberAttributes.emailHash && subscriberAttributes.email === subscriberAttributes.emailHash){
				this.config.disabled = true;
			}
		}
	},

	hooks: {
		_attach: function($element, options){
			if(this.model.mailingListID){
				this.fieldToModel('mailingListID', this.model.mailingListID);
			}

			var primaryKey = ((this.resourceData.data || {}).attributes || {})[(this.resourceData.data || {}).primaryKey || 'id'];
			var $emailField = this.$.find('[data-field-code="email"]');
			if(primaryKey && $emailField.length > 0){
				$emailField.attr('disabled', 'disabled');
			}
		}
	}
};